import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UserInfoService } from '../../services/user-info.service';

@Component({
  selector: 'app-form-iframe',
  templateUrl: './form-iframe.component.html',
  styleUrls: ['./form-iframe.component.less']
})
export class FormIframeComponent implements OnInit {

  public isIframeLoading = true;

  @ViewChild('iframe') iframe: ElementRef;
  @Input() public iFrameLink: string;
  constructor(public userInfoService: UserInfoService) {

  }

  ngOnInit():void {
    this.userInfoService.setSessionCookies();
  }

  iframeLoadingEvent(val:any):void {
    this.isIframeLoading = false;
  }
}
